import axios from "axios";
import { Message } from "element-ui";
import qs from "qs";
import { urlcode } from "@/config.js";
import { showLoading, hideLoading } from "@/utils/loading";

//false为线上环境，true为本地环境
let isVip = true;
function checkStatus(response) {
  // loading
  // 如果http状态码正常，则直接返回数据
  if (
    response &&
    (response.status === 200 ||
      response.status === 304 ||
      response.status === 400)
  ) {
    return response;
    // 如果不需要除了data之外的数据，可以直接 return response.data
  }
  // 异常状态下，把错误信息返回去
  return {
    status: -404,
    msg: "网络异常"
  };
}
function checkCode(res) {
  // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
  if (res.data.status === 404) {
    console.log("网络错误，服务器错误，后端抛出的错误");
  }
  if (res.data && res.data.stateCode !== "001") {
    // console.log(res.data.message)
  }
  return res;
}
function returnError(res) {
  return res;
}

export default {
  post(url, data, isJson) {
    // console.log('url',url)
    showLoading();
    console.log(isJson, "isJson");
    const token = sessionStorage.getItem("token");
    let newurl = url.trim();
    let dataParams;
    isJson ? (dataParams = data) : (dataParams = qs.stringify(data));
    if (token) {
      var requireHeader = {
        "Content-Type": isJson
          ? "application/json;"
          : "application/x-www-form-urlencoded; charset=UTF-8",
        // "Content-Type":"application/json;",
        "X-Access-Token": token
      };
    } else {
      var requireHeader = {
        "Content-Type": isJson
          ? "application/json;"
          : "application/x-www-form-urlencoded; charset=UTF-8"
      };
    }
    // console.log(requireHeader)
    url = urlcode + newurl;

    return axios({
      withCredentials: true,
      crossDomain: true,
      method: "post",
      //  baseURL: '',
      url,
      data: dataParams,
      timeout: 50000,
      headers: requireHeader
    })
      .then(res => {
        hideLoading();
        if (res.data.success || res.data.succeed) {
          return checkCode(res);
        } else {
          this.loading = false;
          Message({
            message: res.data.message || "",
            type: "error",
            duration: 2000
          });
          return checkCode(res);
        }
      })
      .catch(res => {
        hideLoading();
        // console.log(res)
        this.loading = false;
        Message({
          showClose: true,
          message: res.response.data.message || "",
          type: "error"
        });
        if (res.response.status == 401) {
          sessionStorage.removeItem("token");
        }
        return returnError(res);
      });
  },

  get(url, params, isLoading) {
    if (isLoading && isLoading === true) {
      showLoading();
    }
    // const headerAuth = sessionStorage.getItem('headerAuth')
    const token = sessionStorage.getItem("token");
    if (token) {
      var requireHeader = {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        "X-Access-Token": token
      };
    } else {
      var requireHeader = {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
      };
    }
    let newurl = url.trim();
    // if (!isVip) {
    //   url = 'https://md.meton.vip/api_store/rest/api/' + newurl
    // } else {
    //   url = 'http://192.168.28.210:7000' + newurl    //老孙

    // }
    url = urlcode + newurl;
    return axios({
      withCredentials: true,
      crossDomain: true,
      method: "get",
      // baseURL: '',
      url,
      params, // get 请求时带的参数
      timeout: 50000,
      headers: requireHeader
      // responseType: "blob"
    })
      .then(res => {
        hideLoading();
        if (res.data.success == true || res.data.succeed == true) {
          return checkCode(res);
        } else {
          this.loading = false;
          Message({
            message: res.data.message || res.data.error.msg,
            type: "error",
            duration: 2000
          });
          return checkCode(res);
        }
      })
      .catch(res => {
        hideLoading();
        this.loading = false;
        Message({
          showClose: true,
          message: res.response.data.message,
          type: "error"
        });
        if (res.response.status == 401) {
          sessionStorage.removeItem("token");
        }
      });
  },
  put(url, data, isJson) {
    showLoading();
    const token = sessionStorage.getItem("token");
    let newurl = url.trim();
    let dataParams;
    isJson ? (dataParams = data) : (dataParams = qs.stringify(data));
    if (token) {
      var requireHeader = {
        "Content-Type": isJson
          ? "application/json;"
          : "application/x-www-form-urlencoded; charset=UTF-8",
        // "Content-Type":"application/json;",
        "X-Access-Token": token
      };
    } else {
      var requireHeader = {
        "Content-Type": isJson
          ? "application/json;"
          : "application/x-www-form-urlencoded; charset=UTF-8"
      };
    }
    url = urlcode + newurl;

    return axios({
      withCredentials: true,
      crossDomain: true,
      method: "put",
      //  baseURL: '',
      url,
      data: dataParams,
      timeout: 50000,
      headers: requireHeader
    })
      .then(res => {
        hideLoading();
        if (res.data.success == true) {
          return checkCode(res);
        } else {
          this.loading = false;
          Message({
            message: res.data.message,
            type: "error",
            duration: 2000
          });
          return;
        }
      })
      .catch(res => {
        hideLoading();
        // console.log(res)
        this.loading = false;
        Message({
          showClose: true,
          message: res.response.data.message,
          type: "error"
        });
        if (res.response.status == 401) {
          sessionStorage.removeItem("token");
        }

        return returnError(res);
      });
  },
  delete(url, params, url2) {
    showLoading();
    const token = sessionStorage.getItem("token");
    if (token) {
      var requireHeader = {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        "X-Access-Token": token
      };
    } else {
      var requireHeader = {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
      };
    }
    let newurl = url.trim();
    url = urlcode + newurl;
    return axios({
      withCredentials: true,
      crossDomain: true,
      method: "delete",
      // baseURL: '',
      url,
      params, // get 请求时带的参数
      timeout: 50000,
      headers: requireHeader
    })
      .then(res => {
        hideLoading();
        if (res.data.success == true) {
          return checkCode(res);
        } else {
          this.loading = false;
          Message({
            message: res.data.message,
            type: "error",
            duration: 2000
          });
          return;
        }
      })
      .catch(res => {
        hideLoading();
        this.loading = false;
        Message({
          showClose: true,
          message: res.response.data.message,
          type: "error"
        });
        if (res.response.status == 401) {
          sessionStorage.removeItem("token");
        }
      });
  }
};



// WEBPACK FOOTER //
// ./src/utils/request.js